import { ImagesPressLogosGoldBlueSpiritorySvg } from '@/assets/images_press_logos_gold-blue.assets';
import isStringDefined from '../is-string-defined';

export function getBlogContributorImage(image: unknown) {
  if (typeof image === 'string' && isStringDefined(image)) {
    return image;
  }

  return ImagesPressLogosGoldBlueSpiritorySvg.src;
}
